import { Route } from 'react-router-dom';

// Import every panel page from the panel app — single source of truth.
// Keep this file in sync with apps/panel/src/App.tsx so the web shell
// can serve the full /panel/* tree without falling through to the
// public-web wildcard redirect.

import Dashboard from '../../panel/src/pages/Dashboard';
import Home from '../../panel/src/pages/Home';

import AllProducts from '../../panel/src/pages/product/AllProducts';
import NewProduct from '../../panel/src/pages/product/NewProduct';
import ProductAnalytics from '../../panel/src/pages/product/Analytics';
import BulkProduct from '../../panel/src/pages/product/BulkProduct';
import BulkQrPrint from '../../panel/src/pages/product/BulkQrPrint';

import AllCategories from '../../panel/src/pages/category/AllCategories';
import NewCategory from '../../panel/src/pages/category/NewCategory';
import CategoryAnalytics from '../../panel/src/pages/category/Analytics';
import BulkCategory from '../../panel/src/pages/category/BulkCategory';

import AllStores from '../../panel/src/pages/store/AllStores';
import NewStore from '../../panel/src/pages/store/NewStore';
import StoreAnalytics from '../../panel/src/pages/store/Analytics';
import BulkStore from '../../panel/src/pages/store/BulkStore';

import AllStock from '../../panel/src/pages/stock/AllStock';
import NewStock from '../../panel/src/pages/stock/NewStock';
import StockAnalytics from '../../panel/src/pages/stock/Analytics';
import BulkStock from '../../panel/src/pages/stock/BulkStock';

import AllSalesOrders from '../../panel/src/pages/sales-order/AllSalesOrders';
import NewSalesOrder from '../../panel/src/pages/sales-order/NewSalesOrder';
import SalesOrderAnalytics from '../../panel/src/pages/sales-order/Analytics';
import BulkSalesOrder from '../../panel/src/pages/sales-order/BulkSalesOrder';

import AllUsers from '../../panel/src/pages/user/AllUsers';
import NewUser from '../../panel/src/pages/user/NewUser';
import UserAnalytics from '../../panel/src/pages/user/Analytics';
import BulkUser from '../../panel/src/pages/user/BulkUser';

import AllEmployees from '../../panel/src/pages/employee/AllEmployees';
import NewEmployee from '../../panel/src/pages/employee/NewEmployee';
import EmployeeAnalytics from '../../panel/src/pages/employee/Analytics';
import BulkEmployee from '../../panel/src/pages/employee/BulkEmployee';

import AllWarehouses from '../../panel/src/pages/warehouse/AllWarehouses';
import NewWarehouse from '../../panel/src/pages/warehouse/NewWarehouse';
import BulkWarehouse from '../../panel/src/pages/warehouse/BulkWarehouse';

import AllCompanies from '../../panel/src/pages/company/AllCompanies';
import NewCompany from '../../panel/src/pages/company/NewCompany';
import BulkCompany from '../../panel/src/pages/company/BulkCompany';

import AllAttributes from '../../panel/src/pages/attribute/AllAttributes';
import NewAttribute from '../../panel/src/pages/attribute/NewAttribute';
import BulkAttribute from '../../panel/src/pages/attribute/BulkAttribute';

import AllAttributeValues from '../../panel/src/pages/attribute-value/AllAttributeValues';
import NewAttributeValue from '../../panel/src/pages/attribute-value/NewAttributeValue';
import BulkAttributeValue from '../../panel/src/pages/attribute-value/BulkAttributeValue';

import AllRoles from '../../panel/src/pages/role/AllRoles';
import NewRole from '../../panel/src/pages/role/NewRole';
import BulkRole from '../../panel/src/pages/role/BulkRole';

import AllInvoices from '../../panel/src/pages/invoice/AllInvoices';
import NewInvoice from '../../panel/src/pages/invoice/NewInvoice';
import InvoicePreview from '../../panel/src/pages/invoice/InvoicePreview';
import InvoiceAnalytics from '../../panel/src/pages/invoice/Analytics';
import BulkInvoice from '../../panel/src/pages/invoice/BulkInvoice';

import AllPayments from '../../panel/src/pages/payment/AllPayments';
import NewPayment from '../../panel/src/pages/payment/NewPayment';
import BulkPayment from '../../panel/src/pages/payment/BulkPayment';

import AllExpenses from '../../panel/src/pages/expense/AllExpenses';
import NewExpense from '../../panel/src/pages/expense/NewExpense';
import ExpenseAnalytics from '../../panel/src/pages/expense/Analytics';
import BulkExpense from '../../panel/src/pages/expense/BulkExpense';

import AllPurchaseOrders from '../../panel/src/pages/purchase-order/AllPurchaseOrders';
import NewPurchaseOrder from '../../panel/src/pages/purchase-order/NewPurchaseOrder';
import PurchaseOrderAnalytics from '../../panel/src/pages/purchase-order/Analytics';
import BulkPurchaseOrder from '../../panel/src/pages/purchase-order/BulkPurchaseOrder';

import AllAttendances from '../../panel/src/pages/attendance/AllAttendances';
import NewAttendance from '../../panel/src/pages/attendance/NewAttendance';
import BulkAttendance from '../../panel/src/pages/attendance/BulkAttendance';

import AllPayrolls from '../../panel/src/pages/payroll/AllPayrolls';
import NewPayroll from '../../panel/src/pages/payroll/NewPayroll';
import BulkPayroll from '../../panel/src/pages/payroll/BulkPayroll';

import AllAccounts from '../../panel/src/pages/account/AllAccounts';
import NewAccount from '../../panel/src/pages/account/NewAccount';
import BulkAccount from '../../panel/src/pages/account/BulkAccount';

import AllJournalEntries from '../../panel/src/pages/journal-entry/AllJournalEntries';
import NewJournalEntry from '../../panel/src/pages/journal-entry/NewJournalEntry';
import BulkJournalEntry from '../../panel/src/pages/journal-entry/BulkJournalEntry';

import AllMenus from '../../panel/src/pages/menu/AllMenus';
import NewMenu from '../../panel/src/pages/menu/NewMenu';
import BulkMenu from '../../panel/src/pages/menu/BulkMenu';

import AllLicenses from '../../panel/src/pages/license/AllLicenses';
import NewLicense from '../../panel/src/pages/license/NewLicense';
import BulkLicense from '../../panel/src/pages/license/BulkLicense';

import AllFeatures from '../../panel/src/pages/feature/AllFeatures';
import NewFeature from '../../panel/src/pages/feature/NewFeature';
import BulkFeature from '../../panel/src/pages/feature/BulkFeature';

import AllBankTransactions from '../../panel/src/pages/bank-transaction/AllBankTransactions';
import NewBankTransaction from '../../panel/src/pages/bank-transaction/NewBankTransaction';
import BulkBankTransaction from '../../panel/src/pages/bank-transaction/BulkBankTransaction';

import AllOrderReturns from '../../panel/src/pages/order-return/AllOrderReturns';
import NewOrderReturn from '../../panel/src/pages/order-return/NewOrderReturn';
import BulkOrderReturn from '../../panel/src/pages/order-return/BulkOrderReturn';

import AllStockMovements from '../../panel/src/pages/stock-movement/AllStockMovements';
import NewStockMovement from '../../panel/src/pages/stock-movement/NewStockMovement';
import BulkStockMovement from '../../panel/src/pages/stock-movement/BulkStockMovement';

import AllTenants from '../../panel/src/pages/tenant/AllTenants';
import NewTenant from '../../panel/src/pages/tenant/NewTenant';
import MigrateTenant from '../../panel/src/pages/tenant/MigrateTenant';
import AllTenantDomainMaps from '../../panel/src/pages/tenant-domain-map/AllTenantDomainMaps';
import NewTenantDomainMap from '../../panel/src/pages/tenant-domain-map/NewTenantDomainMap';
import AllLedgerEntries from '../../panel/src/pages/ledger-entry/AllLedgerEntries';
import AllStockAdjustments from '../../panel/src/pages/stock-adjustment/AllStockAdjustments';
import NewStockAdjustment from '../../panel/src/pages/stock-adjustment/NewStockAdjustment';
import AllStockTransfers from '../../panel/src/pages/stock-transfer/AllStockTransfers';
import NewStockTransfer from '../../panel/src/pages/stock-transfer/NewStockTransfer';
import AllSalaryStructures from '../../panel/src/pages/salary-structure/AllSalaryStructures';
import NewSalaryStructure from '../../panel/src/pages/salary-structure/NewSalaryStructure';
import AllSubscriptionPlans from '../../panel/src/pages/subscription-plan/AllSubscriptionPlans';
import NewSubscriptionPlan from '../../panel/src/pages/subscription-plan/NewSubscriptionPlan';
import RoleMenuPermissions from '../../panel/src/pages/role-menu/RoleMenuPermissions';
import UserProfile from '../../panel/src/pages/profile/UserProfile';
import AllBanners from '../../panel/src/pages/banner/AllBanners';
import NewBanner from '../../panel/src/pages/banner/NewBanner';
// Storefront CMS — dynamic Our Story / Contact Us / FAQ / shipping etc.
// Missing here would silently fall through to the `*` wildcard and
// redirect the admin back to `/` (the storefront home), which is
// exactly the SSO(2) issue-1 symptom reported by the client.
import AllPageContents from '../../panel/src/pages/page-content/AllPageContents';
import NewPageContent from '../../panel/src/pages/page-content/NewPageContent';
import AllBrands from '../../panel/src/pages/brand/AllBrands';
import NewBrand from '../../panel/src/pages/brand/NewBrand';
import AllUnits from '../../panel/src/pages/unit/AllUnits';
import NewUnit from '../../panel/src/pages/unit/NewUnit';

import SpreadsheetPage from '../../panel/src/pages/SpreadsheetPage';
import Components from '../../panel/src/pages/Components';

/**
 * Returns the full set of `/panel/*` child routes as a fragment so the
 * web app can mount the same backoffice tree the standalone panel app
 * exposes. Without this, clicking sidebar links like "All Stores" or
 * "All Warehouses" would fall through to the wildcard `/` redirect and
 * silently sign the user out.
 *
 * NOTE: this is a plain function (not a component) — call it as
 * `{renderPanelRoutes()}` inside the parent `<Route path="/panel">`.
 * React Router v6's `createRoutesFromChildren` recurses through
 * `React.Fragment` but NOT through custom components, so wrapping the
 * Routes in a `<PanelRoutes />` component would silently produce an
 * empty route tree.
 */
export function renderPanelRoutes() {
  return (
    <>
      <Route index element={<Home />} />
      <Route path="dashboard" element={<Home />} />
      <Route path="demo" element={<Dashboard />} />

      <Route path="employees" element={<AllEmployees />} />
      <Route path="employees/dashboard" element={<EmployeeAnalytics />} />
      <Route path="employees/bulk" element={<BulkEmployee />} />
      <Route path="employees/new" element={<NewEmployee />} />
      <Route path="employees/:id" element={<NewEmployee />} />

      <Route path="attendance" element={<AllAttendances />} />
      <Route path="attendance/bulk" element={<BulkAttendance />} />
      <Route path="attendance/new" element={<NewAttendance />} />
      <Route path="attendance/:id" element={<NewAttendance />} />

      <Route path="payrolls" element={<AllPayrolls />} />
      <Route path="payrolls/bulk" element={<BulkPayroll />} />
      <Route path="payrolls/new" element={<NewPayroll />} />
      <Route path="payrolls/:id" element={<NewPayroll />} />

      <Route path="products" element={<AllProducts />} />
      <Route path="products/dashboard" element={<ProductAnalytics />} />
      <Route path="products/bulk" element={<BulkProduct />} />
      {/* Bulk QR sheet — must appear before `:id` so the literal
          segment wins the match. See apps/panel/src/App.tsx for the
          mirror registration. */}
      <Route path="products/qr-print" element={<BulkQrPrint />} />
      <Route path="products/new" element={<NewProduct />} />
      <Route path="products/:id" element={<NewProduct />} />

      <Route path="categories" element={<AllCategories />} />
      <Route path="categories/dashboard" element={<CategoryAnalytics />} />
      <Route path="categories/bulk" element={<BulkCategory />} />
      <Route path="categories/new" element={<NewCategory />} />
      <Route path="categories/:id" element={<NewCategory />} />

      <Route path="stores" element={<AllStores />} />
      <Route path="stores/dashboard" element={<StoreAnalytics />} />
      <Route path="stores/bulk" element={<BulkStore />} />
      <Route path="stores/new" element={<NewStore />} />
      <Route path="stores/:id" element={<NewStore />} />

      <Route path="warehouses" element={<AllWarehouses />} />
      <Route path="warehouses/bulk" element={<BulkWarehouse />} />
      <Route path="warehouses/new" element={<NewWarehouse />} />
      <Route path="warehouses/:id" element={<NewWarehouse />} />

      <Route path="companies" element={<AllCompanies />} />
      <Route path="companies/bulk" element={<BulkCompany />} />
      <Route path="companies/new" element={<NewCompany />} />
      <Route path="companies/:id" element={<NewCompany />} />

      <Route path="attributes" element={<AllAttributes />} />
      <Route path="attributes/bulk" element={<BulkAttribute />} />
      <Route path="attributes/new" element={<NewAttribute />} />
      <Route path="attributes/:id" element={<NewAttribute />} />

      <Route path="attribute-values" element={<AllAttributeValues />} />
      <Route path="attribute-values/bulk" element={<BulkAttributeValue />} />
      <Route path="attribute-values/new" element={<NewAttributeValue />} />
      <Route path="attribute-values/:id" element={<NewAttributeValue />} />

      <Route path="stock" element={<AllStock />} />
      <Route path="stock/dashboard" element={<StockAnalytics />} />
      <Route path="stock/bulk" element={<BulkStock />} />
      <Route path="stock/new" element={<NewStock />} />
      <Route path="stock/:id" element={<NewStock />} />

      <Route path="stock-movements" element={<AllStockMovements />} />
      <Route path="stock-movements/bulk" element={<BulkStockMovement />} />
      <Route path="stock-movements/new" element={<NewStockMovement />} />
      <Route path="stock-movements/:id" element={<NewStockMovement />} />

      <Route path="sales-orders" element={<AllSalesOrders />} />
      <Route path="sales-orders/dashboard" element={<SalesOrderAnalytics />} />
      <Route path="sales-orders/bulk" element={<BulkSalesOrder />} />
      <Route path="sales-orders/new" element={<NewSalesOrder />} />
      <Route path="sales-orders/:id" element={<NewSalesOrder />} />

      <Route path="order-returns" element={<AllOrderReturns />} />
      <Route path="order-returns/bulk" element={<BulkOrderReturn />} />
      <Route path="order-returns/new" element={<NewOrderReturn />} />
      <Route path="order-returns/:id" element={<NewOrderReturn />} />

      <Route path="purchase-orders" element={<AllPurchaseOrders />} />
      <Route path="purchase-orders/dashboard" element={<PurchaseOrderAnalytics />} />
      <Route path="purchase-orders/bulk" element={<BulkPurchaseOrder />} />
      <Route path="purchase-orders/new" element={<NewPurchaseOrder />} />
      <Route path="purchase-orders/:id" element={<NewPurchaseOrder />} />

      <Route path="invoices" element={<AllInvoices />} />
      <Route path="invoices/dashboard" element={<InvoiceAnalytics />} />
      <Route path="invoices/bulk" element={<BulkInvoice />} />
      <Route path="invoices/new" element={<NewInvoice />} />
      <Route path="invoices/:id/preview" element={<InvoicePreview />} />
      <Route path="invoices/:id" element={<NewInvoice />} />

      <Route path="payments" element={<AllPayments />} />
      <Route path="payments/bulk" element={<BulkPayment />} />
      <Route path="payments/new" element={<NewPayment />} />
      <Route path="payments/:id" element={<NewPayment />} />

      <Route path="expenses" element={<AllExpenses />} />
      <Route path="expenses/dashboard" element={<ExpenseAnalytics />} />
      <Route path="expenses/bulk" element={<BulkExpense />} />
      <Route path="expenses/new" element={<NewExpense />} />
      <Route path="expenses/:id" element={<NewExpense />} />

      <Route path="bank-transactions" element={<AllBankTransactions />} />
      <Route path="bank-transactions/bulk" element={<BulkBankTransaction />} />
      <Route path="bank-transactions/new" element={<NewBankTransaction />} />
      <Route path="bank-transactions/:id" element={<NewBankTransaction />} />

      <Route path="accounts" element={<AllAccounts />} />
      <Route path="accounts/bulk" element={<BulkAccount />} />
      <Route path="accounts/new" element={<NewAccount />} />
      <Route path="accounts/:id" element={<NewAccount />} />

      <Route path="journal-entries" element={<AllJournalEntries />} />
      <Route path="journal-entries/bulk" element={<BulkJournalEntry />} />
      <Route path="journal-entries/new" element={<NewJournalEntry />} />
      <Route path="journal-entries/:id" element={<NewJournalEntry />} />

      <Route path="users" element={<AllUsers />} />
      <Route path="users/dashboard" element={<UserAnalytics />} />
      <Route path="users/bulk" element={<BulkUser />} />
      <Route path="users/new" element={<NewUser />} />
      <Route path="users/:id" element={<NewUser />} />

      <Route path="roles" element={<AllRoles />} />
      <Route path="roles/bulk" element={<BulkRole />} />
      <Route path="roles/new" element={<NewRole />} />
      <Route path="roles/:id" element={<NewRole />} />

      <Route path="menus" element={<AllMenus />} />
      <Route path="menus/bulk" element={<BulkMenu />} />
      <Route path="menus/new" element={<NewMenu />} />
      <Route path="menus/:id" element={<NewMenu />} />

      <Route path="role-menus" element={<RoleMenuPermissions />} />
      <Route path="profile" element={<UserProfile />} />
      <Route path="banners" element={<AllBanners />} />
      <Route path="banners/new" element={<NewBanner />} />
      <Route path="banners/:id" element={<NewBanner />} />
      {/* CMS pages — Our Story / Contact Us / FAQ etc. Mirrors the
          matching block in apps/panel/src/App.tsx so the web shell
          renders the CMS instead of falling through to `/`. */}
      <Route path="pages" element={<AllPageContents />} />
      <Route path="pages/new" element={<NewPageContent />} />
      <Route path="pages/:id" element={<NewPageContent />} />
      <Route path="brands" element={<AllBrands />} />
      <Route path="brands/new" element={<NewBrand />} />
      <Route path="brands/:id" element={<NewBrand />} />
      <Route path="units" element={<AllUnits />} />
      <Route path="units/new" element={<NewUnit />} />
      <Route path="units/:id" element={<NewUnit />} />

      <Route path="licenses" element={<AllLicenses />} />
      <Route path="licenses/bulk" element={<BulkLicense />} />
      <Route path="licenses/new" element={<NewLicense />} />
      <Route path="licenses/:id" element={<NewLicense />} />

      <Route path="features" element={<AllFeatures />} />
      <Route path="features/bulk" element={<BulkFeature />} />
      <Route path="features/new" element={<NewFeature />} />
      <Route path="features/:id" element={<NewFeature />} />

      <Route path="tenants" element={<AllTenants />} />
      <Route path="tenants/new" element={<NewTenant />} />
      <Route path="tenants/migrate" element={<MigrateTenant />} />
      <Route path="tenants/:id" element={<NewTenant />} />

      <Route path="tenant-domain-maps" element={<AllTenantDomainMaps />} />
      <Route path="tenant-domain-maps/new" element={<NewTenantDomainMap />} />
      <Route path="tenant-domain-maps/:id" element={<NewTenantDomainMap />} />

      <Route path="ledger-entries" element={<AllLedgerEntries />} />

      <Route path="stock-adjustments" element={<AllStockAdjustments />} />
      <Route path="stock-adjustments/new" element={<NewStockAdjustment />} />
      <Route path="stock-adjustments/:id" element={<NewStockAdjustment />} />

      <Route path="stock-transfers" element={<AllStockTransfers />} />
      <Route path="stock-transfers/new" element={<NewStockTransfer />} />
      <Route path="stock-transfers/:id" element={<NewStockTransfer />} />

      <Route path="salary-structures" element={<AllSalaryStructures />} />
      <Route path="salary-structures/new" element={<NewSalaryStructure />} />
      <Route path="salary-structures/:id" element={<NewSalaryStructure />} />

      <Route path="subscription-plans" element={<AllSubscriptionPlans />} />
      <Route path="subscription-plans/new" element={<NewSubscriptionPlan />} />
      <Route path="subscription-plans/:id" element={<NewSubscriptionPlan />} />

      <Route path="components" element={<Components />} />
      <Route path="spreadsheet" element={<SpreadsheetPage />} />
    </>
  );
}
